import { ISelectFieldModel } from "../../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";
import { EventType } from "../../../../../common/enums";
import { PageMode } from "../../../../../common/types";

/**
 * Whether the class wizard offers the recurring visitors: a new group class that repeats,
 * and any duplicated group class (it starts with the attendees of the copied occurrence),
 * repeating or not. Never on an edit, never for an individual class.
 */
export const showsRecurringVisitors = (
  pageMode: PageMode,
  type?: EventType | null,
  isRecurring?: boolean | null,
) => {
  if (type === EventType.Individual) return false;
  if (pageMode === "duplicate") return true;
  return pageMode === "add" && !!isRecurring;
};

/**
 * The attendees of the copied occurrence the duplicate starts with: only the ones the
 * visitors picker can show (active clients of this studio).
 */
export const getDuplicateVisitorIds = (
  attendeeUserIds?: number[] | null,
  availableUsers?: ISelectFieldModel[] | null,
) => {
  const availableIds = new Set((availableUsers ?? []).map((user) => user.id));
  return (attendeeUserIds ?? []).filter((id) => availableIds.has(id));
};
